/* eslint-disable import/no-extraneous-dependencies */
import { createTheme } from '@material-ui/core'
import './fonts/poppins.css'
import 'typeface-roboto'

export const theme = createTheme({
  palette: {
    primary: {
      light: '#93c3ea',
      main: '#539fdd',
      dark: '#2679be',
      contrastText: '#fff',
    },
    secondary: {
      light: '#93c3ea',
      main: '#539fdd',
      dark: '#2679be',
      contrastText: '#fff',
    },
    danger: {
      light: '#ffebee',
      main: '#e84118',
    },
  },
  typography: {
    fontSize: 14,
    color: '#2d2f33',
    useNextVariants: true,
    fontFamily: 'Roboto',
    h4: {
      fontWeight: 'bold',
    },
    body1: {
      fontSize: 14,
    },
  },
  icon: 'theme',
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '*': {
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
        },
        '*::-webkit-scrollbar': {
          width: 6,
          height: 6,
        },
        '*::-webkit-scrollbar-track': {
          backgroundColor: 'transparent',
        },
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          borderRadius: 8,
        },
        '*::-webkit-scrollbar-thumb:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
        },
      },
    },
  },
})
